import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
// tslint:disable-next-line:no-unused-variable
import { Translate, translate, ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { ISite } from 'app/shared/model/site.model';
import { getEntities as getSites } from 'app/entities/site/site.reducer';
import { getEntity, updateEntity, createEntity, reset } from './zone.reducer';
import { IZone } from 'app/shared/model/zone.model';
// tslint:disable-next-line:no-unused-variable
import { convertDateTimeFromServer } from 'app/shared/util/date-utils';
import { keysToValues } from 'app/shared/util/entity-utils';

export interface IZoneUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: number }> {}

export interface IZoneUpdateState {
  isNew: boolean;
  siteId: number;
}

export class ZoneUpdate extends React.Component<IZoneUpdateProps, IZoneUpdateState> {
  constructor(props) {
    super(props);
    this.state = {
      siteId: 0,
      isNew: !this.props.match.params || !this.props.match.params.id
    };
  }

  componentDidMount() {
    if (this.state.isNew) {
      this.props.reset();
    } else {
      this.props.getEntity(this.props.match.params.id);
    }

    this.props.getSites();
  }

  saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const { zoneEntity } = this.props;
      const entity = {
        ...zoneEntity,
        ...values
      };

      if (this.state.isNew) {
        this.props.createEntity(entity);
      } else {
        this.props.updateEntity(entity);
      }
      this.handleClose();
    }
  };

  handleClose = () => {
    this.props.history.push('/entity/zone');
  };

  siteUpdate = element => {
    const id = element.target.value.toString();
    if (id === '') {
      this.setState({
        siteId: -1
      });
    } else {
      for (const i in this.props.sites) {
        if (id === this.props.sites[i].id.toString()) {
          this.setState({
            siteId: this.props.sites[i].id
          });
        }
      }
    }
  };

  render() {
    const isInvalid = false;
    const { zoneEntity, sites, loading, updating } = this.props;
    const { isNew } = this.state;

    return (
      <div>
        <Row className="justify-content-center">
          <Col md="8">
            <h2 id="rtnApp.zone.home.createOrEditLabel">
              <Translate contentKey="rtnApp.zone.home.createOrEditLabel">Create or edit a Zone</Translate>
            </h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <AvForm model={isNew ? {} : zoneEntity} onSubmit={this.saveEntity}>
                {!isNew ? (
                  <AvGroup>
                    <Label for="id">
                      <Translate contentKey="global.field.id">ID</Translate>
                    </Label>
                    <AvInput id="zone-id" type="text" className="form-control" name="id" required readOnly />
                  </AvGroup>
                ) : null}
                <AvGroup>
                  <Label id="nameLabel" for="name">
                    <Translate contentKey="rtnApp.zone.name">Name</Translate>
                  </Label>
                  <AvField id="zone-name" type="text" name="name" />
                </AvGroup>
                <AvGroup>
                  <Label id="autoArrangeAscLabel" check>
                    <AvInput id="zone-autoArrangeAsc" type="checkbox" className="form-control" name="autoArrangeAsc" />
                    <Translate contentKey="rtnApp.zone.autoArrangeAsc">Auto Arrange Asc</Translate>
                  </Label>
                </AvGroup>
                <AvGroup>
                  <Label for="site.id">
                    <Translate contentKey="rtnApp.zone.site">Site</Translate>
                  </Label>
                  <AvInput id="zone-site" type="select" className="form-control" name="site.id" onChange={this.siteUpdate}>
                    <option value="" key="0" />
                    {sites
                      ? sites.map(otherEntity => (
                          <option value={otherEntity.id} key={otherEntity.id}>
                            {otherEntity.id}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="zone-site" type="hidden" name="site.id" value={this.state.siteId} />
                </AvGroup>
                <Button tag={Link} id="cancel-save" to="/entity/zone" replace color="info">
                  <FontAwesomeIcon icon="arrow-left" />&nbsp;
                  <span className="d-none d-md-inline">
                    <Translate contentKey="entity.action.back">Back</Translate>
                  </span>
                </Button>
                &nbsp;
                <Button color="primary" id="save-entity" type="submit" disabled={isInvalid || updating}>
                  <FontAwesomeIcon icon="save" />&nbsp;
                  <Translate contentKey="entity.action.save">Save</Translate>
                </Button>
              </AvForm>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  sites: storeState.site.entities,
  zoneEntity: storeState.zone.entity,
  loading: storeState.zone.loading,
  updating: storeState.zone.updating
});

const mapDispatchToProps = {
  getSites,
  getEntity,
  updateEntity,
  createEntity,
  reset
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ZoneUpdate);
